import React from 'react';
import { ArrowUp } from 'lucide-react';

const STATE_CLASSES = {
    stopping: 'bg-gray-100 text-gray-400 cursor-not-allowed',
    streaming: 'bg-gray-100 hover:bg-gray-200 text-brand-blue-500',
    disabled: 'bg-gray-200 text-gray-400 cursor-not-allowed',
    ready: 'bg-brand-blue-500 hover:bg-brand-blue-600 text-white',
};

const resolveState = ({ isStopping, isStreaming, isDisabled }) => {
    if (isStopping) return 'stopping';
    if (isStreaming) return 'streaming';
    if (isDisabled) return 'disabled';
    return 'ready';
};

export default function ComposerSendButton({
    isStopping,
    isStreaming,
    isDisabled,
    onSend,
    onTerminate,
    buttonDisabled,
    iconSize = 'w-4 h-4',
    streamingBlock = 'w-3 h-3',
}) {
    const state = resolveState({ isStopping, isStreaming, isDisabled });
    const onClick = isStopping ? undefined : (isStreaming ? onTerminate : onSend);

    return (
        <button
            type="button"
            onClick={onClick}
            disabled={buttonDisabled}
            className={`w-7 h-7 rounded-full flex items-center justify-center transition-all duration-200 ${STATE_CLASSES[state]}`}
        >
            {state === 'stopping' ? (
                <div className="w-3.5 h-3.5 border-2 border-gray-400 border-t-transparent rounded-full animate-spin" />
            ) : state === 'streaming' ? (
                <div className={`${streamingBlock} bg-current rounded-sm`} />
            ) : (
                <ArrowUp className={iconSize} />
            )}
        </button>
    );
}
